module.exports = __webpack_public_path__ + "static/media/prizes.61a7763d.webp";